import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default function SubmitButton({ onTap }) {
  useEffect(
    () => $('#wrapper').off('tap.submitButton', '#submit-btn:not(.disabled)'),
    [],
  );

  const tapCallback = useCallback(
    (e) => {
      e.preventDefault();
      // if not disabled
      onTap();
    },
    [onTap],
  );

  return (
    <div
      className={classNames('submit-btn-container text-center', {
        'submit-btn-container-extra-margin': Pollfish.helper.hasIOSNavigator(),
      })}
    >
      <button
        type="button"
        className="btn btn-w-icon"
        id="submit-btn"
        data-btn="submit-btn"
        onClick={tapCallback}
        aria-label="Submit answers"
      >
        <span className="icon-check"></span>
      </button>
    </div>
  );
}

SubmitButton.propTypes = {
  onTap: PropTypes.func,
};
